import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: flex-end;

  .ordenation-label {
    font-size: 14px;
    color: ${(props) => props.theme.colors.neutral600};
    white-space: nowrap;
  }

  .ordenation-select {
    min-width: 180px;
  }
`;

export const OptionContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;

  svg {
    flex-shrink: 0;
  }
`;
